import React, { useEffect, useState } from 'react';
import MetaTags from 'react-meta-tags';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Container, Label, Row,
} from "reactstrap";
import { IsCBMManagment, IsSweetAndSnacksCompany, amountCommaSeparateFunc, breadcrumbReturnFunc, date_ymd_func, loginPartyID, loginSelectedPartyID, loginUserIsFranchisesRole } from '../../../components/Common/CommonFunction';
import * as url from "../../../routes/route_url";
import * as pageId from "../../../routes/allPageID"
import { commonPageField, commonPageFieldSuccess, } from '../../../store/actions';
import * as mode from "../../../routes/PageMode"
import { clearDashboard, getDashbordDetails, getDashbordDetails_Success } from '../../../store/Dashboard/Dashboard_1_Redux/action';

import { DashboardLoader, PageLoadingSpinner } from '../../../components/Common/CommonButton';


import Pie from '../FrenchiesesDashboard/pie';
import { ERP_LINK } from '../../../helpers/_serverPath';
import { formatDate, GetDailySaleData } from '../FrenchiesesDashboard/Function';

import { C_DatePicker } from '../../../CustomValidateForm';
import PosExeVersionDetails from '../FrenchiesesDashboard/PosExeVersionDetails';
import { getMaterialIssueListPage } from '../../../store/Production/Matrial_Issue/action';
import { getWorkOrderListPage } from '../../../store/Production/WorkOrder/action';
import InvoiceForGRN from '../Dashboard_1/GRNList';


const getRealToday = () => {
    const d = new Date();
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = d.getFullYear();
    return `${yy}-${mm}-${dd}`;
};


const Frenchises_Dashboard = (props) => {

    const history = useHistory()
    const dispatch = useDispatch();
    const IsCompanySweetAndSnacks = IsSweetAndSnacksCompany()
    const [userPageAccessState, setUserAccState] = useState('');
    const [selectedOption, setSelectedOption] = useState('TODAYS');
    const [data, setData] = useState([]);
    const [amountLoading, setAmountLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);




    const isFrenchises = loginUserIsFranchisesRole()
    const IsMannagementParty = IsCBMManagment();

    const [customDateRange, setCustomDateRange] = useState({
        fromDate: date_ymd_func(),
        toDate: date_ymd_func(),
    });

    // 🔹 NEW — this is what actually drives the fetch. selectedOption /
    // customDateRange are just the "pending" picks the user is making;
    // nothing is fetched until they click Go, which copies the currently
    // effective dates into this state.
    const [appliedDateRange, setAppliedDateRange] = useState({
        fromDate: date_ymd_func(),
        toDate: date_ymd_func(),
    });

    //Access redux store Data /  'save_ModuleSuccess' action data
    const {
        getDashboard,
        userAccess,
        workOrderList,
        GRNListLoading,
        pageField,
        SalesReturnListloading,
        PaymentEntryListloading,
        commonPartyDropSelect,
        materialIssueList,
        challanList } = useSelector((state) => ({
            getDashboard: state.DashboardReducer.getDashboard,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageField,
            orderApprovalMsg: state.OrderReducer.orderApprovalMsg,
            GRNListLoading: state.OrderReducer.goBtnLoading,
            SalesReturnListloading: state.SalesReturnReducer.loading,
            PaymentEntryListloading: state.ReceiptReducer.loading,
            commonPartyDropSelect: state.CommonPartyDropdownReducer.commonPartyDropSelect,
            workOrderList: state.WorkOrderReducer.WorkOrderList,
            materialIssueList: state.MaterialIssueReducer.materialIssueList,
            challanList: state.ChallanReducer.ChallanList
        }));

    const { OrderCount, InvoiceCount, GRNsCount, MobileAppOrderCount } = getDashboard

    useEffect(() => {
        const page_Id = pageId.Frenchises_Dashboard//changes
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(page_Id))


    }, []);

    useEffect(() => {
        const partyId = commonPartyDropSelect?.value;

        // No party selected
        if (!partyId || partyId <= 0) {
            dispatch(clearDashboard());
            return;
        }

        // Fetch dashboard for currently selected party
        dispatch(
            getDashbordDetails({
                loginPartyID: partyId,
            })
        );

    }, [commonPartyDropSelect?.value, dispatch]);
    const [hoveredIdx, setHoveredIdx] = useState(null);
    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty(mode.editValue)//changes
    const pendingWO = workOrderList.filter(
        i => i.RemainingLot > 0 || i.RemaningQty > 0
    ).length;

    const pendingMI = materialIssueList.filter(
        i => i.Status !== 2 && Number(i.Percentage) < 100
    ).length;

    const pendingGRNQty = challanList?.filter(
        item => Number(item.inward) === 0
    ).length || 0;




    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;

        if (hasShowModal) {
            locationPath = props.masterPath;
        };

        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })

        if (userAcc) {
            setUserAccState(userAcc)
            breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])



    function InvoiceFoRGRN_onClick() {
        if (IsCompanySweetAndSnacks) {
            history.push(url.IB_GRN_LIST)
        } else {
            history.push(url.GRN_STP_3)
        }
    }

    // CHANGED — accepts an optional override so handleChange can compute
    // dates from the value just clicked, not the not-yet-updated `selectedOption`.
    const getEffectiveDates = (optionOverride) => {
        const option = optionOverride ?? selectedOption;
        const today = new Date();
        switch (option) {
            case 'TODAYS': {
                const d = formatDate(today);
                return { fromDate: d, toDate: d };
            }
            case 'YESTERDAY': {
                const y = new Date(today);
                y.setDate(today.getDate() - 1);
                const d = formatDate(y);
                return { fromDate: d, toDate: d };
            }
            case 'MONTH': {
                const first = new Date(today.getFullYear(), today.getMonth(), 1);
                return { fromDate: formatDate(first), toDate: formatDate(today) };
            }
            case 'SIX_MONTH': {
                const six = new Date(today);
                six.setMonth(today.getMonth() - 6);
                return { fromDate: formatDate(six), toDate: formatDate(today) };
            }
            case 'CUSTOM':
                return { fromDate: customDateRange.fromDate, toDate: customDateRange.toDate };
            default: {
                const d = formatDate(today);
                return { fromDate: d, toDate: d };
            }
        }
    };

    const handleChange = (event) => {
        const value = event.target.value;
        setSelectedOption(value);

        // Presets fetch immediately. Custom still waits for Go, since the
        // user needs to actually pick both dates first.
        if (value !== "CUSTOM") {
            const { fromDate, toDate } = getEffectiveDates(value);
            setAppliedDateRange({ fromDate, toDate });
        }
    };


    // 🔹 NEW — Go button handler. Reads whatever is currently selected
    // (dropdown option, or the custom picker values) and applies it, which
    // is what actually triggers the fetch effect below.
    const handleGoClick = () => {
        const { fromDate, toDate } = getEffectiveDates();
        setAppliedDateRange({ fromDate, toDate });
    };

    useEffect(() => {
        const { fromDate, toDate } = getEffectiveDates('TODAYS');
        setSelectedOption('TODAYS');
        setAppliedDateRange({ fromDate, toDate });
    }, []);


    const RedirectHandler = (Type) => {
        if (Type === 1) {
            history.push(url.ORDER_LIST_4)

        } else if (Type === 2) {
            (isFrenchises || IsMannagementParty) ? history.push(url.POS_INVOICE_LIST) : history.push(url.INVOICE_LIST_1)
        }
        else if (Type === 3) {
            history.push(url.APP_ORDER_LIST)
        } else {
            history.push(url.GRN_LIST_3)
        }
    }

    // 🔹 CHANGED — now depends on appliedDateRange (set only by Go / initial
    // mount) instead of selectedOption + customDateRange directly, so
    // changing the dropdown or the date pickers no longer auto-fetches.
    // Party selection still auto-fetches using whatever date range was last
    // applied, matching prior behavior for party changes.
    useEffect(() => {
        if (!loginPartyID()) return;
        if (!commonPartyDropSelect?.value) return;

        let isMounted = true;

        const fetchData = async () => {
            setLoadingData(true);
            setAmountLoading(true);
            setData([]);              // ← clear stale data immediately, no flash

            try {
                const jsonData = await GetDailySaleData({
                    fromDate: appliedDateRange.fromDate,
                    toDate: appliedDateRange.toDate,
                    Party_Id: commonPartyDropSelect.value,
                });

                if (isMounted) {
                    setData(jsonData?.Data || []);
                }
            } catch (error) {
                console.error("Error fetching dashboard data", error);
            } finally {
                if (isMounted) {
                    setLoadingData(false);
                    setAmountLoading(false);
                }
            }
        };

        fetchData();
        return () => { isMounted = false; };

    }, [
        appliedDateRange.fromDate,
        appliedDateRange.toDate,
        commonPartyDropSelect?.value,
    ]);

    useEffect(() => {
        if (!IsCompanySweetAndSnacks) return;
        if (!commonPartyDropSelect || commonPartyDropSelect.value <= 0) return;

        const today = getRealToday();
        const partyId = loginSelectedPartyID();

        // 1️⃣ Work Order List (JSON STRING REQUIRED)
        dispatch(
            getWorkOrderListPage({
                jsonBody: JSON.stringify({
                    FromDate: today,
                    ToDate: today,
                    Party: partyId,
                }),
                subPageMode: url.WORK_ORDER_LIST,
            })
        );

        // 2️⃣ Material Issue List (PLAIN OBJECT ONLY ❗)
        dispatch(
            getMaterialIssueListPage({
                FromDate: today,
                ToDate: today,
                Party: partyId,
            })
        );
    }, [IsCompanySweetAndSnacks, commonPartyDropSelect]);

    const encodeId = (id) => {
        return btoa(id.toString()); // Converts ID to Base64 encoded string
    };
    const toDMY = (d) => (d ? d.split("-").reverse().join("-") : "");

    const hasPageAccess = (actualPagePath) => {
        return userAccess.some(
            page => page.ActualPagePath === actualPagePath
        );
    };

    const renderKPICard = (item, idx, { showAccent = false } = {}) => {
        const isActive = item.value > 0 || item.alwaysActive;
        const isHovered = hoveredIdx === idx && isActive && item.hasAccess;

        return (
            <div
                onMouseEnter={() => isActive && setHoveredIdx(idx)}
                onMouseLeave={() => setHoveredIdx(null)}
                onClick={isActive && item.hasAccess ? item.onClick : undefined}
                style={{
                    cursor: item.hasAccess ? "pointer" : "not-allowed",
                    background: "#ffffff",
                    border: "1px solid #eaeaea",
                    borderLeft: !showAccent ? `4px solid ${item.color}` : undefined,
                    borderRadius: "8px",
                    padding: "12px 14px",
                    height: "72px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    // opacity: item.hasAccess ? 1 : 0.55,

                    /* 🔥 SAME hover effect */
                    transform: isHovered ? "translateY(-2px)" : "translateY(0)",
                    boxShadow: isHovered
                        ? "0 6px 14px rgba(0,0,0,0.08)"
                        : "none",
                    transition: "all 0.18s ease-in-out",
                }}
            >
                {/* Optional top accent (Pending KPI style) */}
                {showAccent && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: isHovered ? "56px" : "40px",
                            height: "4px",
                            background: item.color,
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                            transition: "width 0.18s ease-in-out",
                        }}
                    />
                )}

                <div
                    style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        marginBottom: "2px",
                        fontWeight: 600,
                    }}
                >
                    {item.title}
                </div>

                <div
                    style={{
                        fontSize: "22px",
                        fontWeight: 600,
                        color: isActive ? "#212529" : "#ced4da",
                        lineHeight: "1.2",
                    }}
                >
                    {item.value}
                </div>
            </div>
        );
    };

    const topKPIs = [
        {
            title: "Total Orders",
            value: OrderCount,
            hasAccess: hasPageAccess("OrderList_4"),
            onClick: () => RedirectHandler(1),
            color: "#4e73df",
            alwaysActive: true,
        },
        {
            title: "Total Invoices",
            value: InvoiceCount,
            hasAccess: (isFrenchises || IsMannagementParty) ? hasPageAccess("Pos_InvoiceList") : hasPageAccess("InvoiceList_1"),
            onClick: () => RedirectHandler(2),
            color: "#36b9cc",
            alwaysActive: true,
        },
        {
            title: "Total GRNs",
            value: GRNsCount,
            hasAccess: hasPageAccess("GRN_LIST_3"),
            onClick: () => RedirectHandler(),
            color: "#f6c23e",
            alwaysActive: true,
        },
    ].filter(Boolean);

    const pendingKPIs = [
        {
            title: "Pending GRN",
            value: pendingGRNQty,
            color: "#8fb9a8",
            hasAccess: hasPageAccess("IB_INVOICE_FOR_GRN"),
            onClick: () => history.push(url.IB_INVOICE_FOR_GRN),
            alwaysActive: true,
        },
        {
            title: "Pending Work Order",
            value: pendingWO,
            color: "#9aa7bd",
            hasAccess: hasPageAccess("MaterialIssue_STP"),
            onClick: () => history.push(url.MATERIAL_ISSUE_STP),
            alwaysActive: true,
        },
        {
            title: "Pending Material Issue",
            value: pendingMI,
            color: "#c49a9a",
            hasAccess: hasPageAccess("Production_STP"),
            onClick: () => history.push(url.PRODUCTION_STP),
            alwaysActive: true,
        },

    ];



    return (
        <React.Fragment>
            <PageLoadingSpinner isLoading={GRNListLoading || PaymentEntryListloading || SalesReturnListloading || !pageField} />
            <div className="page-content" style={{
                backgroundColor: "#f4f6fb",
                minHeight: "100vh",
                paddingBottom: "20px",
            }}>
                <MetaTags>
                    <title>Dashboard | FoodERP 2.0 - React Admin & Dashboard Template</title>
                </MetaTags>
                <Container fluid>

                    <Row style={{ marginBottom: "12px" }}>
                        {topKPIs.map((item, idx) => (
                            <Col xl={4} md={4} key={idx}>
                                {renderKPICard(
                                    { ...item, alwaysActive: true },
                                    idx
                                )}
                            </Col>
                        ))}
                    </Row>

                    <Row>

                        <Col lg={6}>
                            <Card style={{
                                borderRadius: "14px",
                                border: "none",
                                backgroundColor: "#ffffff",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                marginBottom: "16px",
                                height: "350px",
                            }}>
                                <CardHeader
                                    style={{
                                        backgroundColor: "transparent",
                                        borderBottom: "1px solid #eef0f4",
                                        padding: "14px 16px 12px",
                                    }}
                                >
                                    {/* ROW 1 — Title + View Report link */}
                                    <div className="d-flex align-items-center justify-content-between">
                                        <Label
                                            style={{
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#343a40",
                                                marginBottom: 0,
                                            }}
                                        >
                                            Daily Top 5 Selling Items
                                        </Label>

                                        <a
                                            href={`${ERP_LINK}${url.DAILY_SALE_REPORT}/${encodeId(loginPartyID())}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                fontSize: "12px",
                                                fontWeight: 600,
                                                color: "#4e73df",
                                                textDecoration: "none",
                                                whiteSpace: "nowrap",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                padding: "5px 10px",
                                                borderRadius: "8px",
                                                backgroundColor: "rgba(78,115,223,0.08)",
                                                transition: "background-color 0.15s ease",
                                            }}
                                            onMouseEnter={e =>
                                                (e.currentTarget.style.backgroundColor = "rgba(78,115,223,0.14)")
                                            }
                                            onMouseLeave={e =>
                                                (e.currentTarget.style.backgroundColor = "rgba(78,115,223,0.08)")
                                            }
                                        >
                                            View Daily Sales Report ↗
                                        </a>
                                    </div>

                                    {/* ROW 2 — always visible (no data condition anymore) */}
                                    <div
                                        className="d-flex align-items-start justify-content-between flex-wrap"
                                        style={{ marginTop: "12px", gap: "10px" }}
                                    >
                                        <div>
                                            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                                <select
                                                    className="form-select form-select-sm"
                                                    style={{
                                                        borderRadius: "8px",
                                                        fontSize: "12px",
                                                        padding: "6px 30px 6px 12px",
                                                        backgroundColor: "#fff",
                                                        border: "1px solid #dee2e6",
                                                        minWidth: "120px",
                                                    }}
                                                    value={selectedOption}
                                                    onChange={handleChange}
                                                >
                                                    <option value="TODAYS">Today's</option>
                                                    <option value="YESTERDAY">Yesterday</option>
                                                    <option value="MONTH">Month</option>
                                                    <option value="SIX_MONTH">Six Month</option>
                                                    <option value="CUSTOM">Custom</option>
                                                </select>
                                            </div>

                                            {selectedOption === "CUSTOM" && (
                                                <div
                                                    className="d-flex align-items-center"
                                                    style={{ marginTop: "8px", gap: "8px" }}
                                                >
                                                    <C_DatePicker
                                                        options={{
                                                            altInput: true,
                                                            altFormat: "d-m-Y",
                                                            dateFormat: "Y-m-d",
                                                            maxDate: "today",
                                                        }}
                                                        name="FromDate"
                                                        value={customDateRange.fromDate}
                                                        onChange={(e, date) => {
                                                            setCustomDateRange(prev => ({ ...prev, fromDate: date }));
                                                        }}
                                                    />
                                                    <span style={{ fontSize: "12px", color: "#adb5bd" }}>to</span>
                                                    <C_DatePicker
                                                        options={{
                                                            altInput: true,
                                                            altFormat: "d-m-Y",
                                                            dateFormat: "Y-m-d",
                                                            maxDate: "today",
                                                        }}
                                                        name="ToDate"
                                                        value={customDateRange.toDate}
                                                        onChange={(e, date) => {
                                                            setCustomDateRange(prev => ({ ...prev, toDate: date }));
                                                        }}
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={handleGoClick}
                                                        disabled={loadingData}
                                                        style={{
                                                            border: "none",
                                                            borderRadius: "8px",
                                                            padding: "6px 16px",
                                                            fontSize: "12px",
                                                            fontWeight: 600,
                                                            color: "#ffffff",
                                                            backgroundColor: loadingData ? "#a9b6e8" : "#4e73df",
                                                            cursor: loadingData ? "not-allowed" : "pointer",
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: "6px",
                                                            whiteSpace: "nowrap",
                                                            transition: "background-color 0.15s ease",
                                                        }}
                                                    >
                                                        {loadingData && (
                                                            <span
                                                                className="spinner-border spinner-border-sm"
                                                                role="status"
                                                                style={{ width: "10px", height: "10px", borderWidth: "2px" }}
                                                            ></span>
                                                        )}
                                                        Go
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        <div>
                                            {amountLoading ? (
                                                <span
                                                    className="badge rounded-pill badge-soft-primary d-flex align-items-center justify-content-center"
                                                    style={{ fontSize: "16px", padding: "8px 16px" }}
                                                >
                                                    <div className="spinner-border spinner-border-sm text-primary"></div>
                                                </span>
                                            ) : (
                                                <span
                                                    className="badge rounded-pill badge-soft-primary fw-large"
                                                    style={{ fontSize: "16px", padding: "8px 16px" }}
                                                >
                                                    ₹ {data[0]?.TotalAmount ? amountCommaSeparateFunc(data[0].TotalAmount) : 0}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </CardHeader>

                                <CardBody style={{
                                    padding: "12px 16px",
                                    overflowY: "auto",
                                }}>
                                    {loadingData ? (
                                        <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{ height: "260px" }}
                                        >
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    ) : data[0]?.TopSaleItems?.length > 0 ? (
                                        <Pie
                                            Item={data[0].TopSaleItems}
                                            overallSalesAmount={data[0]?.TotalAmount}
                                            key={`${appliedDateRange.fromDate}_${appliedDateRange.toDate}`}
                                        />
                                    ) : (
                                        <div
                                            className="d-flex flex-column align-items-center justify-content-center text-center"
                                            style={{ height: "230px", padding: "0 16px" }}
                                        >
                                            {/* Soft icon circle, same blue as the "View Daily Sales Report" button */}
                                            <div
                                                style={{
                                                    width: "64px",
                                                    height: "64px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "rgba(78,115,223,0.08)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    marginBottom: "14px",
                                                }}
                                            >
                                                <i
                                                    className="bx bx-pie-chart-alt-2"
                                                    style={{ fontSize: "30px", color: "#4e73df" }}
                                                ></i>
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: 600,
                                                    color: "#343a40",
                                                    marginBottom: "4px",
                                                }}
                                            >
                                                No data available
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: "12px",
                                                    color: "#6c757d",
                                                    maxWidth: "240px",
                                                    lineHeight: 1.5,
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                No items were sold in this period. Try a different date range.
                                            </div>

                                            {/* Shows which dates were searched */}
                                            <span
                                                style={{
                                                    fontSize: "11px",
                                                    fontWeight: 600,
                                                    color: "#4e73df",
                                                    backgroundColor: "rgba(78,115,223,0.08)",
                                                    borderRadius: "999px",
                                                    padding: "4px 12px",
                                                }}
                                            >
                                                {appliedDateRange.fromDate === appliedDateRange.toDate
                                                    ? toDMY(appliedDateRange.fromDate)
                                                    : `${toDMY(appliedDateRange.fromDate)}  →  ${toDMY(appliedDateRange.toDate)}`}
                                            </span>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>


                        <Col md={6}>
                            <Card style={{
                                borderRadius: "14px",
                                border: "none",
                                backgroundColor: "#ffffff",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                marginBottom: "16px",
                                height: "350px",
                                overflowY: "auto",
                            }}>
                                <CardHeader style={{
                                    backgroundColor: "transparent",
                                    borderBottom: "1px solid #eef0f4",
                                    padding: "12px 16px",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "#343a40",
                                }}
                                    className="d-flex align-items-center">
                                    <Label

                                        disabled={GRNListLoading}
                                        onClick={InvoiceFoRGRN_onClick}
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            color: "#4e73df",
                                            cursor: "pointer",
                                        }}

                                    >
                                        Invoices For GRN</Label>
                                    {(GRNListLoading) &&
                                        <DashboardLoader />
                                    }
                                </CardHeader>
                                <InvoiceForGRN />

                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        {(IsMannagementParty) && <Col lg={12}>
                            <Card style={{
                                borderRadius: "14px",
                                border: "none",
                                backgroundColor: "#ffffff",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                marginBottom: "16px",
                            }}>

                                <PosExeVersionDetails />

                            </Card>
                        </Col>}
                    </Row>

                </Container>
            </div>
        </React.Fragment >
    );
}

export default Frenchises_Dashboard;